import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { SalesContractTemplateHdrContainerModel } from "../../../../../../models/aggregates/erp/sales-contract";

@Injectable({ providedIn: 'root' })
export class SalesContractTemplateHdrService extends BaseApiTemplateService<SalesContractTemplateHdrContainerModel> {

    static readonly SALES_CONTRACT_TEMPLATE_HDR_SUBPATH = 'sales-contract-template-hdrs/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + SalesContractTemplateHdrService.SALES_CONTRACT_TEMPLATE_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + SalesContractTemplateHdrService.SALES_CONTRACT_TEMPLATE_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}